
<template>
  <v-container fluid class="pb-0">
    <v-form ref="dateForm" lazy-validation>
      <v-row align="center" justify="center">
        <v-col class="py-0" cols='5' md='4' >
          <!-- <v-text-field v-model="start_date" prepend-icon="mdi-calendar" label="Início"></v-text-field> -->
          <v-menu
            ref="menu_start"
            v-model="menu_start"
            :close-on-content-click="false"
            :return-value.sync="start_date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :value="start_date? $moment(start_date).format('L') : null" label="Início" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" ></v-text-field>
            </template>
            <v-date-picker v-model="start_date" no-title scrollable :max='end_date' >
              <v-spacer></v-spacer>
              <v-btn text @click="menu_start = false" > fechar </v-btn>
              <v-btn text color="primary" @click="$refs.menu_start.save(start_date)" > OK </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0" cols='5' md='4' >
          <!-- <v-text-field v-model="end_date" prepend-icon="mdi-calendar" label="Término"></v-text-field> -->
          <v-menu
            ref="menu_end"
            v-model="menu_end"
            :close-on-content-click="false"
            :return-value.sync="end_date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :disabled='!start_date' :value="end_date? $moment(end_date).format('L') : null" label="Término" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" ></v-text-field>
            </template>
            <v-date-picker v-model="end_date" no-title scrollable :min='start_date'>
              <v-spacer></v-spacer>
              <v-btn text @click="menu_end = false" > fechar </v-btn>
              <v-btn text color="primary" @click="$refs.menu_end.save(end_date)" > OK </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0" cols='1'>
          <v-btn icon color="primary" @click="sendDates()"><v-icon>mdi-magnify</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'

export default {
  mixins: [ validations ],
  data() {
    return {
      start_date: null,
      end_date: null,
      menu_start: false,
      menu_end: false,

    }
  },
  props: {
    default_month_range_date: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    sendDates() {
      if (this.$refs.dateForm.validate()){
        let obj = {
          start_date: this.start_date,
          end_date: this.end_date,
        }
        this.$emit('onDateSearch', obj)
      }
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    start_date(nv,ov) {
      if (nv){
        this.$refs.menu_start.save(nv)
      } else if (nv == false){
      }
    },
    end_date(nv,ov) {
      if (nv){
        this.$refs.menu_end.save(nv)
      } else if (nv == false){
      }
    }
  },
  mounted () {
    if(this.default_month_range_date){
      this.start_date = this.$moment().startOf('month').format('YYYY-MM-DD');
      this.end_date = this.$moment().endOf('month').format('YYYY-MM-DD');
    }
  },
}
</script>

<style scoped>

</style>